module.exports = __webpack_public_path__ + "img/41.e6485966.svg";